<template>
  <div id="classroomForm" class="form">
    <v-alert type="warning" v-if="globalCenter && !globalCenter.id"
      >Choose a location first</v-alert
    >

    <v-card-title>
      {{ id ? "Edit " : "Add " }} {{ terminologies.classroom }}
      <v-spacer />
      <v-btn icon @click="goBack"><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>

    <v-card-text>
      <v-form
        v-if="loaded"
        ref="form"
        v-model="valid"
        lazy-validation
        class="mt-5"
      >
        <v-text-field
          v-model="classroom.roomNumber"
          outlined
          label="Room Number/Name"
          :required="true"
        />
        <v-text-field
          v-model="classroom.maxCapacity"
          outlined
          label="Max. Capacity"
          type="number"
        />
        <v-textarea
          outlined
          v-model="classroom.description"
          label="Description"
          :rows="3"
        />

        <v-sheet class="d-md-flex">
          <v-sheet class="flex-column"> </v-sheet>
          <v-spacer></v-spacer>

          <v-sheet class="justify-right text-right">
            <v-btn @click="goBack" plain class="mr-4"> Back </v-btn>

            <v-btn
              @click="handleSubmit"
              color="primary"
              rounded
              x-large
              :disabled="globalCenter && !globalCenter.id"
            >
              {{ id ? "Update" : "Save" }}
            </v-btn>
          </v-sheet>
        </v-sheet>
      </v-form>
    </v-card-text>
  </div>
</template>

<script>
import { getClassroom } from "@/services/classroom";
import { mapActions, mapGetters } from "vuex";

export default {
  props: ["id", "isModal"],
  data() {
    return {
      loaded: false,
      valid: false,
      classroom: {
        relations: {},
        roomNumber: "",
        maxCapacity: "",
        description: "",
      },
    };
  },
  watch: {
    id: function (val) {
      console.log(val);
      this.setInstance();
    },
  },
  created() {
    this.setInstance();
  },
  computed: {
    ...mapGetters("navigation", ["isAppLoading", "globalCenter"]),
    ...mapGetters("terminology", ["terminologies"]),
  },
  methods: {
    ...mapActions("classroom", ["createClassroom", "updateClassroom"]),
    ...mapActions("messages", [
      "addMessage",
      "addErrorMessage",
      "addSuccessMessage",
    ]),

    async handleSubmit() {
      if (this.id) {
        let classroom = this.classroom;
        delete classroom.relations;

        this.updateClassroom(classroom)
          .then(() => {
            this.$emit("onReload");
            this.addSuccessMessage("Classroom was updated successfully");
            this.goBack();
          })
          .catch(() => {
            this.addErrorMessage(
              "Error updating Classroom, please try again later",
            );
          });
      } else {
        let classroom = this.classroom;
        delete classroom.relations;

        this.createClassroom(classroom)
          .then(() => {
            this.$emit("onReload");
            this.addSuccessMessage("Classroom was created successfully");
            if (this.isModal) {
              this.onCloseDialog();
            } else {
              this.goBack();
            }
          })
          .catch(() => {
            this.addErrorMessage(
              "Error creating Classroom, please try again later",
            );
          });
      }
    },
    goBack() {
      if (this.isModal) {
        this.onCloseDialog();
      } else {
        this.$router.go(-1);
      }
    },
    setInstance() {
      if (this.id) {
        this.classroom.id = this.id;
        getClassroom(this.id).then((response) => {
          let instance = response.data;
          for (let property in instance) {
            if (
              Object.prototype.hasOwnProperty.call(instance, property) &&
              Object.prototype.hasOwnProperty.call(this.classroom, property)
            ) {
              this.classroom[property] = instance[property];
            }
          }
          this.loaded = true;
        });
      } else {
        this.loaded = true;
      }
      this.setDependencies();
    },
    setDependencies() {},
    onCloseDialog() {
      this.id = null;
      this.$emit("clicked", "closeClassroomDialog");
      this.$refs.form.reset();
    },
  },
  components: {},
};
</script>
